import { createIcon } from '@chakra-ui/icons';

export const EmailIcon = createIcon({
  displayName: 'EmailIcon',
  viewBox: '0 0 16 17',
  path: [
    <path
      key="1"
      d="M14.3681 3.16679C14.3075 3.16055 14.2464 3.16055 14.1859 3.16679H1.74141C1.66166 3.16802 1.58243 3.17998 1.50586 3.20235L7.92808 9.5979L14.3681 3.16679Z"
      fill="currentColor"
    />,
    <path
      key="2"
      d="M15.0263 3.78418L8.5552 10.2286C8.38866 10.3942 8.16336 10.4871 7.92853 10.4871C7.6937 10.4871 7.46841 10.3942 7.30187 10.2286L0.888533 3.83307C0.868817 3.90553 0.858364 3.9802 0.857422 4.05529V12.9442C0.857422 13.1799 0.951072 13.406 1.11777 13.5727C1.28447 13.7394 1.51056 13.8331 1.74631 13.8331H14.1908C14.4265 13.8331 14.6526 13.7394 14.8193 13.5727C14.986 13.406 15.0796 13.1799 15.0796 12.9442V4.05529C15.0761 3.96269 15.0581 3.87122 15.0263 3.78418ZM2.3552 12.9442H1.73742V12.3086L4.96853 9.10418L5.5952 9.73085L2.3552 12.9442ZM14.1819 12.9442H13.5596L10.3196 9.73085L10.9463 9.10418L14.1774 12.3086L14.1819 12.9442Z"
      fill="currentColor"
    />,
  ],
});
